const en = {
	title: 'Select the trade type',
	subtitle: 'In order to comply with regulatory requirements, please select the trade type of your business from the following options',
	tip: 'Tips：If you are carrying out different types of business, please apply for mutiple PingPong Checkout accounts',
	tradeOfGoods: 'Goods',
	tradeOfService: 'Service',
	confirm: 'Confirm',
	cancel: 'Log Out',
	pleaseSelectOne: 'Please select the type',
	whenConfirming: 'The trade type of {#@email@#} is "{#@type@#}" which can not be modified after confirmation. Confirm or not？',
	tipWord: 'Attention',
	cancelWord: 'Cancel',
	activedWrods: 'Only websites whose type is "{#@type@#}" can be added under this account.',
	onSuccessTip: 'Success',
	accountType: 'Type of Merchant',
	businessType: 'Business Type',
	onlineService: 'Online Service',
	offlineServices: 'In-Store'
}

export default en
